import type { LiveBoard, LiveOrder } from "@luckymenu/core";

/**
 * "I have paid" from a table (SF-12, P4-T22): the diner says they paid by
 * UPI. The claim stays on the order (`listLive`'s `paymentClaim`) until
 * someone records a payment, on any device, so the alert follows the
 * server. Staff check their own UPI app or soundbox, then Confirm.
 */
export type PaymentClaim = {
	/** A new claim on the same order (a later `at`) is a new alert. */
	key: string;
	orderId: string;
	orderNo: number;
	type: LiveOrder["type"];
	tableLabel: string | null;
	/** `billed` once the bill is issued; an open order is billed before Confirm records it. */
	status: LiveOrder["status"];
	/** The balance the diner saw when they tapped. */
	amountPaise: number;
	at: string;
};

export const claimKey = (orderId: string, at: string) => `${orderId}:${at}`;

/** Claims waiting for a payment, oldest first, without those hidden on this device. */
export function paymentClaims(
	board: Pick<LiveBoard, "orders">,
	hidden: ReadonlySet<string> = new Set(),
): PaymentClaim[] {
	const claims: PaymentClaim[] = [];
	for (const order of board.orders) {
		const claim = order.paymentClaim;
		if (!claim) continue;
		const key = claimKey(order.id, claim.at);
		if (hidden.has(key)) continue;
		claims.push({
			key,
			orderId: order.id,
			orderNo: order.orderNo,
			type: order.type,
			tableLabel: order.tableLabel,
			status: order.status,
			amountPaise: claim.amountPaise,
			at: claim.at,
		});
	}
	return claims.sort((a, b) => a.at.localeCompare(b.at));
}
